module.exports = __webpack_public_path__ + "static/media/ic_folder.7fcd9968.png";